// extracted by mini-css-extract-plugin
export default {"stepTileList":"StepTileList_stepTileList__j6iwG","stepnextArrow":"StepTileList_stepnextArrow__UqElz","stepTileList2":"StepTileList_stepTileList2__r6t4o"};